/* =========================================================
   HAFALO THEME — theme.js
   Vanilla JS, bez závislostí. Každý komponent je samostatný,
   takže výpadok jedného nezhodí zvyšok stránky.
   ========================================================= */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};

  /* ---------------------------------------------------------
     Pomocné funkcie
     --------------------------------------------------------- */

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);

    if (format.indexOf('amount_with_comma_separator') !== -1 || format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      value = value.replace('.', ',');
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else {
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var scrollLockCount = 0;
  var lockedScrollY = 0;

  /* Samotné overflow: hidden na <body> mobilné prehliadače (hlavne iOS)
     ignorujú a stránka pod otvoreným panelom sa roluje ďalej. Preto ju na
     čas otvorenia „zmrazíme“ cez position: fixed a po zatvorení vrátime na
     pôvodné miesto. */
  function lockScroll() {
    scrollLockCount += 1;
    if (scrollLockCount > 1) return;

    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    /* Hlavička pri zamknutí prepína zo sticky na fixed (viď CSS), aby
       ostala prilepená k viewportu – tým ale stráca svoje miesto v toku
       a obsah pod ňou by poskočil hore. Zmeriame jej prirodzenú (dokumentom
       danú, nie od scrollu odvodenú) výšku a o rovnako veľký padding
       posunieme obsah späť.

       getBoundingClientRect().top je vzhľadom k viewportu – akonáhle sa
       odrolovalo nižšie než je výška hlavičky, je záporné (hlavička je
       "nalepená" nad svojou prirodzenou pozíciou v dokumente). Pripočítaním
       lockedScrollY sa vrátime k prirodzenej výške nezávislej od scrollu. */
    var mainContent = document.getElementById('MainContent');
    var headerSpace = mainContent
      ? Math.max(0, mainContent.getBoundingClientRect().top + lockedScrollY)
      : 0;
    document.documentElement.style.setProperty('--scroll-lock-offset', headerSpace + 'px');

    document.body.style.top = -lockedScrollY + 'px';
    document.body.classList.add('is-locked');
  }

  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount !== 0) return;
    releaseScroll();
  }

  function releaseScroll() {
    scrollLockCount = 0;
    if (!document.body.classList.contains('is-locked')) return;

    document.body.classList.remove('is-locked');
    document.body.style.top = '';

    /* Na <html> je scroll-behavior: smooth (kvôli kotvám v stránke). Kým bol
       panel otvorený, telo malo position: fixed, takže stránka je v tej chvíli
       na pozícii 0 – a plynulé rolovanie by návrat na pôvodné miesto ukázalo
       ako viditeľné odrolovanie zhora nadol. Na tento jediný skok ho preto
       vypneme a hneď vrátime späť. */
    var root = document.documentElement;
    var previousBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockedScrollY);
    root.style.scrollBehavior = previousBehavior;
  }

  function showOverlay() {
    var overlay = $('[data-overlay]');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    }
  }

  function hideOverlay() {
    var overlay = $('[data-overlay]');
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.hidden = true; }, 300);
    }
  }

  var toastTimer;

  function toast(message, isError) {
    var el = $('#Toast');
    if (!el) return;
    var text = $('.toast__text', el);
    if (text) text.textContent = message;
    el.classList.toggle('toast--error', !!isError);
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 3200);
  }

  /* Vráti HTML jednej sekcie zo Section Rendering API */
  function fetchSection(sectionId, url) {
    var base = url || window.location.pathname;
    var separator = base.indexOf('?') === -1 ? '?' : '&';
    return fetch(base + separator + 'sections=' + sectionId, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) { return data[sectionId]; });
  }

  function replaceInnerFromHtml(html, selector, target) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.querySelector(selector);
    if (source && target) target.innerHTML = source.innerHTML;
    return source;
  }

  /* ---------------------------------------------------------
     Panely (drawer) – košík a vyhľadávanie
     --------------------------------------------------------- */

  var Drawers = {
    open: function (el) {
      if (!el) return;
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      showOverlay();
      lockScroll();

      var focusTarget = el.querySelector('[data-predictive-input]') || el.querySelector('button, a, input');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 120);
    },

    close: function (el) {
      if (!el || el.hidden) return;
      el.classList.remove('is-open');
      hideOverlay();
      unlockScroll();
      setTimeout(function () { el.hidden = true; }, 300);
    },

    closeAll: function () {
      $$('.cart-drawer, .search-drawer, .mobile-nav').forEach(function (el) {
        if (el.classList.contains('is-open')) {
          el.classList.remove('is-open');
          setTimeout(function () { el.hidden = true; }, 300);
        }
      });

      /* Panel filtrov je na desktope bežná bočná lišta – iba ho zasunieme. */
      $$('.facets.is-open').forEach(function (el) { el.classList.remove('is-open'); });

      hideOverlay();
      releaseScroll();
    }
  };

  /* Konfety pri odomknutí dopravy zdarma – vychádzajú z aktuálne
     viditeľného pruhu (drawer alebo stránka košíka), farby berie
     priamo z CSS premenných, aby sedeli s nastavením v admine. */
  function celebrateFreeShipping() {
    var bars = $$('.shipping-bar--reached');
    var origin = null;
    for (var i = 0; i < bars.length; i++) {
      var r = bars[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) { origin = bars[i]; break; }
    }

    var rect = origin && origin.getBoundingClientRect();
    var originX = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
    var originY = rect ? rect.top + rect.height / 2 : window.innerHeight / 3;

    if (origin) {
      origin.classList.add('is-celebrating');
      setTimeout(function () { origin.classList.remove('is-celebrating'); }, 650);
    }

    var rootStyles = getComputedStyle(document.documentElement);
    var colors = ['--color-primary', '--color-accent', '--color-success', '--color-star'].map(function (name) {
      return rootStyles.getPropertyValue(name).trim();
    });
    colors.push('#ffffff');

    var pieces = [];
    var count = 26;
    for (var j = 0; j < count; j++) {
      var piece = document.createElement('span');
      piece.className = 'confetti-piece';
      piece.style.left = originX + 'px';
      piece.style.top = originY + 'px';
      piece.style.background = colors[j % colors.length];

      var angle = (Math.PI * 2 * j) / count + (Math.random() * 0.6 - 0.3);
      var distance = 70 + Math.random() * 90;
      piece.style.setProperty('--x', (Math.cos(angle) * distance) + 'px');
      piece.style.setProperty('--y', (Math.sin(angle) * distance - 30) + 'px');
      piece.style.setProperty('--r', (Math.random() * 320) + 'deg');
      piece.style.animationDelay = (Math.random() * 0.12) + 's';

      document.body.appendChild(piece);
      pieces.push(piece);
    }

    setTimeout(function () {
      pieces.forEach(function (p) { p.remove(); });
    }, 1400);
  }

  /* ---------------------------------------------------------
     Košík
     --------------------------------------------------------- */

  var Cart = {
    currentCount: 0,
    freeShippingUnlocked: false,

    drawer: function () { return $('#CartDrawer'); },

    checkFreeShipping: function (cart) {
      Cart.updateDeliveryEstimates(cart.total_price);

      if (!theme.cartFreeShippingBar || !theme.cartFreeShippingThreshold) return;
      var unlocked = cart.total_price >= theme.cartFreeShippingThreshold;
      if (unlocked && Cart.freeShippingUnlocked === false) {
        setTimeout(celebrateFreeShipping, 350);
      }
      Cart.freeShippingUnlocked = unlocked;
    },

    /* Riadok "Pri nákupe nad X € doprava zdarma" v odhade doručenia na
       produktovej stránke – prepne sa na "Doprava zdarma!", ak už košík
       spĺňa limit, bez nutnosti obnoviť stránku. */
    updateDeliveryEstimates: function (totalPrice) {
      $$('[data-delivery-estimate]').forEach(function (el) {
        var line = el.querySelector('[data-shipping-line]');
        if (!line) return;

        var threshold = parseInt(el.getAttribute('data-free-shipping-threshold'), 10) || 0;
        if (threshold <= 0) return;

        var reached = totalPrice >= threshold;
        var text = reached ? line.getAttribute('data-text-reached') : line.getAttribute('data-text-default');
        if (!text || line.textContent.trim() === text.trim()) return;

        line.classList.add('is-fading');
        setTimeout(function () {
          line.textContent = text;
          line.classList.toggle('is-free', reached);
          line.classList.remove('is-fading');
        }, 200);
      });
    },

    updateCount: function (count) {
      Cart.currentCount = count;
      $$('[data-cart-count]').forEach(function (el) {
        /* Číslo je v markupe obalené zátvorkami priamo v HTML (Košík (N)) –
           tie zátvorky nie sú súčasťou tohto elementu, takže keby sme ho
           pri 0 skryli, zostali by viditeľné samotné "()" bez čísla. */
        el.textContent = count;
        el.classList.add('is-bumped');
        setTimeout(function () { el.classList.remove('is-bumped'); }, 400);
      });
    },

    /* Vloží už natiahnuté HTML sekcií (z add/change.js s parametrom `sections`)
       bez ďalšieho fetchu. Vráti { itemCount, totalPrice }, ak sa podarilo
       vyčítať z čerstvého <cart-drawer> markupu. */
    applySections: function (sections) {
      var result = {};
      if (!sections) return result;

      var drawer = Cart.drawer();
      if (sections['cart-drawer'] && drawer) {
        var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = parsed.querySelector('cart-drawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          var itemCount = fresh.getAttribute('data-item-count');
          var totalPrice = fresh.getAttribute('data-total-price');
          if (itemCount !== null) result.itemCount = parseInt(itemCount, 10) || 0;
          if (totalPrice !== null) result.totalPrice = parseInt(totalPrice, 10) || 0;
          /* Prekreslením sa stratil pásik s odporúčaniami aj naviazané
             plynulé rozbaľovanie zľavového kódu – naviazať nanovo. */
          CartUpsell.refresh();
          initSmoothDetails(drawer);
        }
      }

      if (sections['main-cart'] && document.body.classList.contains('template-cart')) {
        replaceInnerFromHtml(sections['main-cart'], '.cart-page', $('.cart-page'));
      }

      return result;
    },

    add: function (formData, button) {
      if (button) button.classList.add('is-loading');

      /* Zachytené pred pridaním – po ňom už Cart.currentCount nie je 0 */
      var wasEmpty = Cart.currentCount === 0;

      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', theme.cartUrl);

      return fetch(theme.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function (addedItem) {
          var info = Cart.applySections(addedItem.sections);
          var itemCount = typeof info.itemCount === 'number' ? info.itemCount : Cart.currentCount + (addedItem.quantity || 1);
          Cart.updateCount(itemCount);
          if (typeof info.totalPrice === 'number') Cart.checkFreeShipping({ total_price: info.totalPrice });

          if (theme.cartType === 'drawer') Drawers.open(Cart.drawer());
          if (wasEmpty && addedItem && addedItem.product_id) Upsell.show(addedItem.product_id);
        })
        .then(function () {
          if (theme.cartType !== 'drawer') toast(strings.added || 'Pridané do košíka');
        })
        .catch(function (error) {
          var message = (error && error.description) || (error && error.message) || strings.error;
          toast(message, true);
        })
        .then(function () {
          if (button) button.classList.remove('is-loading');
        });
    },

    change: function (line, quantity) {
      var onCartPage = document.body.classList.contains('template-cart');

      return fetch(theme.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: onCartPage ? 'cart-drawer,main-cart' : 'cart-drawer',
          sections_url: theme.cartUrl
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          Cart.updateCount(cart.item_count);
          Cart.checkFreeShipping(cart);
          Cart.applySections(cart.sections);
        })
        .catch(function () {
          toast(strings.error, true);
        });
    }
  };

  /* ---------------------------------------------------------
     Odporúčané produkty (Shopify Recommendations API)
     --------------------------------------------------------- */

  /* Najprv pýtame `intent=complementary`, teda presne tie doplnkové produkty,
     ktoré si merchant napáruje v aplikácii Shopify Search & Discovery
     (Produkty → Complementary products). Bez tohto parametra Shopify vracia
     len algoritmické „súvisiace“ produkty a ručné párovanie sa vôbec
     nepoužije. Ak dvojice nastavené nie sú (alebo pre daný produkt nič
     nevrátia), padáme späť na `intent=related`, nech pásik neostane prázdny. */
  function fetchRecommendations(options) {
    if (!theme.productRecommendationsUrl) return Promise.resolve(null);

    var base = theme.productRecommendationsUrl +
      '?product_id=' + options.productId +
      '&limit=' + options.limit +
      '&section_id=' + options.sectionId;

    function load(intent) {
      return fetch(base + '&intent=' + intent, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          return parsed.querySelector(options.itemSelector) ? parsed : null;
        });
    }

    return load('complementary').then(function (parsed) {
      return parsed || load('related');
    });
  }

  /* ---------------------------------------------------------
     Popup „Doplňte si nákup“

     Zobrazí sa raz – hneď potom, čo zákazník pridá prvý produkt do
     prázdneho košíka (Cart.add zisťuje wasEmpty). Obsah sú Shopify
     odporúčania pre konkrétny pridaný produkt, vykreslené cez
     sections/upsell-modal.liquid.
     --------------------------------------------------------- */

  var Upsell = {
    modal: function () { return $('#UpsellModal'); },

    /* Popup je zámerne len pre väčšie obrazovky – na mobile/tablete by prekryl
       celý displej hneď po pridaní do košíka, tam preto rovnakú úlohu plní
       pásik priamo v bočnom košíku (.cart-upsell, ten je naopak na desktope
       skrytý – viď theme.css). */
    isSmallScreen: function () {
      return window.matchMedia('(max-width: 989px)').matches;
    },

    show: function (productId) {
      var modal = Upsell.modal();
      if (!modal || !theme.cartUpsellPopup || !theme.productRecommendationsUrl) return;
      if (Upsell.isSmallScreen()) return;

      fetchRecommendations({
        productId: productId,
        sectionId: 'upsell-modal',
        limit: 10,
        itemSelector: '.upsell-modal__item'
      })
        .then(function (parsed) {
          if (!parsed) return;
          var content = parsed.querySelector('[data-upsell-content]');

          var items = content ? Array.from(content.querySelectorAll('.upsell-modal__item')) : [];
          if (!items.length) return;

          items.sort(function() { return 0.5 - Math.random(); });
          var grid = content.querySelector('.upsell-modal__grid');
          grid.innerHTML = '';
          items.slice(0, 3).forEach(function(item) {
            grid.appendChild(item);
          });

          var body = $('[data-upsell-body]', modal);
          if (body) body.innerHTML = content.innerHTML;

          /* Ak je otvorený bočný košík, popup vycentrujeme do priestoru vedľa
             neho – inak by pôsobil posunutý a čiastočne schovaný pod košíkom. */
          var openDrawer = Cart.drawer();
          modal.classList.toggle(
            'upsell-modal--beside-cart',
            !!(openDrawer && openDrawer.classList.contains('is-open'))
          );

          modal.hidden = false;
          requestAnimationFrame(function () {
            modal.classList.add('is-open');
            showOverlay();
          });
        })
        .catch(function () { /* ticho – bez odporúčaní sa popup jednoducho nezobrazí */ });
    },

    close: function () {
      var modal = Upsell.modal();
      if (!modal || modal.hidden) return;

      modal.classList.remove('is-open');
      setTimeout(function () { modal.hidden = true; }, 300);

      /* Nezhasínaj spoločné prekrytie, ak je pod popupom stále otvorený košík */
      var drawer = Cart.drawer();
      if (!drawer || !drawer.classList.contains('is-open')) hideOverlay();
    }
  };

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-upsell-close]')) Upsell.close();

    /* Samotný #UpsellModal je na celú obrazovku (position: fixed; inset: 0)
       a leží NAD zdieľaným prekrytím [data-overlay] – klik na tmavé pozadie
       okolo panelu preto zasiahne modal, nie overlay, a globálny listener
       nižšie (na [data-overlay]) sa vôbec nespustí. Bez tohto sa popup dal
       zavrieť len krížikom alebo Escape, čo pôsobilo, že sa "nedá pokračovať". */
    if (event.target.id === 'UpsellModal') Upsell.close();
  });

  /* ---------------------------------------------------------
     Okno s možnosťami doručenia (pásik „U vás doma …“)
     --------------------------------------------------------- */

  /* Okno musí visieť priamo na <body>. Vnútri produktovej sekcie ho
     zachytávajú stacking contexty predkov – .product-section__info je
     position: sticky a .reveal má transform – takže by sa napriek
     z-indexu 220 kreslilo POD spoločné prekrytie (z-index 170) a pôsobilo
     by zašedlo a rozmazane. Transform predka navyše mení význam
     position: fixed: vzťahoval by sa k nemu, nie k oknu prehliadača. */
  function initShippingInfo() {
    $$('[data-shipping-info]').forEach(function (modal) {
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
    });
  }

  var ShippingInfo = {
    open: function (modal) {
      if (!modal) return;
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        showOverlay();
      });
    },

    close: function () {
      var modal = $('[data-shipping-info].is-open');
      if (!modal) return;

      modal.classList.remove('is-open');
      setTimeout(function () { modal.hidden = true; }, 300);

      /* Nezhasínaj spoločné prekrytie, ak je pod oknom otvorený košík. */
      var drawer = Cart.drawer();
      if (!drawer || !drawer.classList.contains('is-open')) hideOverlay();
    }
  };

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-shipping-info-open]');
    if (trigger) {
      ShippingInfo.open(document.getElementById(trigger.getAttribute('data-shipping-info-open')));
      return;
    }

    if (event.target.closest('[data-shipping-info-close]')) {
      ShippingInfo.close();
      return;
    }

    /* Okno je na celú obrazovku a leží NAD zdieľaným [data-overlay], takže
       klik na tmavé pozadie zasiahne jeho, nie overlay – rovnaký prípad ako
       pri popupe „Doplňte si nákup“ vyššie. */
    if (event.target.matches('[data-shipping-info]')) ShippingInfo.close();
  });

  /* ---------------------------------------------------------
     Pásik „Doplň svoju rutinu“ v bočnom košíku (malé displeje)
     --------------------------------------------------------- */

  /* Server vykreslí zálohu (produkty z rovnakej kolekcie), tu ju prepíšeme
     Shopify odporúčaniami – rovnakým zdrojom, z akého čerpá popup na
     desktope, nech sa na mobile aj na PC ponúka to isté. */
  var CartUpsell = {
    refresh: function () {
      if (!Upsell.isSmallScreen()) return;

      var block = $('[data-cart-upsell]');
      if (!block) return;

      var list = $('[data-cart-upsell-list]', block);
      if (!list) return;

      var productId = block.getAttribute('data-upsell-product');

      if (!theme.productRecommendationsUrl || !productId || block.dataset.recommended) {
        CartUpsell.setupDots(block);
        return;
      }
      block.dataset.recommended = 'true';

      fetchRecommendations({
        productId: productId,
        sectionId: 'cart-upsell',
        limit: 10,
        itemSelector: '.cart-upsell__item'
      })
        .then(function (parsed) {
          if (!parsed) return;
          var content = parsed.querySelector('[data-cart-upsell-content]');
          if (!content || !content.querySelector('.cart-upsell__item')) return;
          list.innerHTML = content.innerHTML;
        })
        .catch(function () { /* ticho – ostane vykreslená záloha zo servera */ })
        .then(function () { CartUpsell.setupDots(block); });
    },

    /* Čiarky vpravo hore – jedna na kartu. Dajú sa klikať (posunú zoznam na
       danú kartu) a pri ručnom posúvaní sa zvýrazní tá najbližšia. */
    setupDots: function (block) {
      var list = $('[data-cart-upsell-list]', block);
      var dots = $('[data-cart-upsell-dots]', block);
      if (!list || !dots) return;

      var items = $$('.cart-upsell__item', list);
      dots.innerHTML = '';

      if (items.length < 2) {
        dots.hidden = true;
        return;
      }
      dots.hidden = false;

      var base = items[0].offsetLeft;

      items.forEach(function (item, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cart-upsell__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Zobraziť produkt ' + (index + 1));
        dot.addEventListener('click', function () {
          list.scrollTo({ left: item.offsetLeft - base, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });

      var dotEls = $$('.cart-upsell__dot', dots);

      function sync() {
        var closest = 0;
        var smallest = Infinity;
        items.forEach(function (item, index) {
          var distance = Math.abs(item.offsetLeft - base - list.scrollLeft);
          if (distance < smallest) {
            smallest = distance;
            closest = index;
          }
        });
        dotEls.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === closest);
        });
      }

      list.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  };

  /* --- Odosielanie formulárov „do košíka“ --- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;

    Cart.add(new FormData(form), button);
  });

  /* --- Otváranie / zatváranie panela --- */
  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-cart-open]');
    if (openBtn && theme.cartType === 'drawer') {
      event.preventDefault();
      Drawers.open(Cart.drawer());
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      Drawers.close(Cart.drawer());
      return;
    }

    var removeBtn = event.target.closest('[data-cart-remove]');
    if (removeBtn) {
      event.preventDefault();
      Cart.change(parseInt(removeBtn.getAttribute('data-line'), 10), 0);
      return;
    }

    var quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      var insideUpsellModal = !!quickAdd.closest('#UpsellModal');
      var data = new FormData();
      data.append('id', quickAdd.getAttribute('data-quick-add'));
      data.append('quantity', 1);
      Cart.add(data, quickAdd).then(function () {
        if (insideUpsellModal) Upsell.close();
      });
    }
  });

  /* --- Zľavový kód v košíku ---
     Kódy uplatňujeme cez Ajax Cart API (/cart/update.js, parameter `discount`),
     takže sa stránka neobnovuje a z odpovede rovno vidíme, či kód zabral.
     Shopify neplatný kód ticho ignoruje – preto po update overíme, či sa
     zadaný kód naozaj objavil medzi uplatnenými zľavami, a inak dáme hlášku.
     Pozor: `discount` vždy prepíše celý zoznam kódov, takže pri pridávaní aj
     odoberaní posielame kompletný zoznam, nie len ten jeden zmenený. */

  function appliedDiscountCodes() {
    var holder = $('[data-applied-discounts]');
    var raw = holder ? holder.getAttribute('data-applied-discounts') : '';
    return (raw || '').split('|')
      .map(function (code) { return code.trim(); })
      .filter(Boolean);
  }

  function setDiscountMessage(text) {
    $$('[data-discount-msg]').forEach(function (msg) {
      msg.textContent = text || '';
      msg.hidden = !text;
      if (!text) return;
      var details = msg.closest('.cart-discount');
      if (details) details.open = true;
    });
  }

  function updateDiscounts(codes) {
    var onCartPage = document.body.classList.contains('template-cart');

    return fetch(theme.cartUpdateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: onCartPage ? 'cart-drawer,main-cart' : 'cart-drawer',
        sections_url: theme.cartUrl
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        Cart.updateCount(cart.item_count);
        Cart.checkFreeShipping(cart);
        Cart.applySections(cart.sections);
        return cart;
      });
  }

  function applyDiscountCode(scope) {
    var input = scope.querySelector('[data-discount-input]');
    if (!input) return;

    var code = input.value.trim();
    if (!code) {
      input.focus();
      return;
    }

    var button = scope.querySelector('[data-discount-apply]');
    if (button) button.classList.add('is-loading');
    setDiscountMessage('');

    var codes = appliedDiscountCodes();
    var alreadyThere = codes.some(function (existing) {
      return existing.toLowerCase() === code.toLowerCase();
    });
    if (!alreadyThere) codes.push(code);

    updateDiscounts(codes)
      .then(function () {
        var label = code.toUpperCase();

        /* Či kód zabral čítame z čerstvo prekresleného markupu, nie z JSON
           odpovede – Liquid vie spoľahlivo rozlíšiť kód od automatickej zľavy. */
        var nowApplied = appliedDiscountCodes().map(function (existing) {
          return existing.toLowerCase();
        });

        if (nowApplied.indexOf(code.toLowerCase()) !== -1) {
          fireConfetti();
          toast('Kód ' + label + ' bol uplatnený.');
          return;
        }

        /* Shopify nerozlišuje dôvod, tak vymenujeme tie bežné. */
        setDiscountMessage('Kód ' + label + ' sa nepodarilo uplatniť – je neplatný, ' +
          'expirovaný, už bol vyčerpaný alebo nespĺňa podmienky (napríklad minimálnu sumu objednávky).');
        toast('Kód ' + label + ' neplatí.', true);

        /* Sekcie sa medzitým prekreslili, tak zadaný kód vrátime do poľa. */
        $$('[data-discount-input]').forEach(function (field) { field.value = code; });
      })
      .catch(function () {
        toast(strings.error, true);
      })
      .then(function () {
        if (button) button.classList.remove('is-loading');
      });
  }

  function removeDiscountCode(code) {
    var codes = appliedDiscountCodes().filter(function (existing) {
      return existing.toLowerCase() !== code.toLowerCase();
    });

    setDiscountMessage('');

    updateDiscounts(codes)
      .then(function () {
        toast('Kód ' + code.toUpperCase() + ' bol odstránený.');
      })
      .catch(function () {
        toast(strings.error, true);
      });
  }

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-discount-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeDiscountCode(removeBtn.getAttribute('data-discount-remove'));
      return;
    }

    var applyBtn = event.target.closest('[data-discount-apply]');
    if (!applyBtn) return;
    event.preventDefault();
    applyDiscountCode(applyBtn.closest('.cart-discount') || document);
  });

  /* --- Tlačidlo "Uplatniť" v snippets/promo-code-badge.liquid ---
     Pridá vybraný variant do košíka a rovno k nemu uplatní promo kód cez
     ten istý AJAX discount systém ako pole v košíku vyššie. */
  document.addEventListener('click', function (event) {
    var promoBtn = event.target.closest('[data-promo-apply]');
    if (!promoBtn || promoBtn.disabled) return;
    event.preventDefault();

    var variantId = promoBtn.getAttribute('data-promo-apply');
    var code = promoBtn.getAttribute('data-promo-code');
    if (!variantId || !code) return;

    var data = new FormData();
    data.append('id', variantId);
    data.append('quantity', 1);

    Cart.add(data, promoBtn).then(function () {
      var codes = appliedDiscountCodes();
      var alreadyThere = codes.some(function (existing) {
        return existing.toLowerCase() === code.toLowerCase();
      });
      if (!alreadyThere) codes.push(code);
      return updateDiscounts(codes);
    }).then(function () {
      var nowApplied = appliedDiscountCodes().map(function (existing) {
        return existing.toLowerCase();
      });
      if (nowApplied.indexOf(code.toLowerCase()) !== -1) {
        fireConfetti();
        toast('Kód ' + code.toUpperCase() + ' bol uplatnený.');
      }
    });
  });

  /* Enter v poli s kódom nesmie odoslať formulár košíka (to by šlo na pokladňu). */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches('[data-discount-input]')) return;
    event.preventDefault();
    applyDiscountCode(event.target.closest('.cart-discount') || document);
  });

  /* Konfety po úspešnom kóde. Vlastný canvas, žiadna knižnica – vykreslí sa
     na pár sekúnd cez celú obrazovku a sám sa odstráni. */
  function fireConfetti() {
    if (!window.requestAnimationFrame) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var css = getComputedStyle(document.documentElement);
    var colors = ['--color-primary', '--color-accent', '--color-sale', '--color-success']
      .map(function (name) { return css.getPropertyValue(name).trim(); })
      .filter(Boolean);
    if (!colors.length) colors = ['#D72638', '#D04186'];
    /* Zlatá a ružová navyše, nech to nie je len v dvoch odtieňoch červenej. */
    colors = colors.concat(['#F7B32B', '#F49AC1']);

    var canvas = document.createElement('canvas');
    canvas.className = 'confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = canvas.width = window.innerWidth * dpr;
    var h = canvas.height = window.innerHeight * dpr;

    /* Dva výbuchy zospodu z oboch strán – vyzerá to sviatočnejšie ako jeden. */
    var particles = [];
    [0.2, 0.8].forEach(function (originX) {
      for (var i = 0; i < 70; i++) {
        var angle = (Math.random() * 0.9 + (originX < 0.5 ? -0.95 : -1.2)) * Math.PI;
        var speed = (Math.random() * 13 + 11) * dpr;
        particles.push({
          x: w * originX,
          y: h * 0.95,
          vx: Math.cos(angle) * speed * (originX < 0.5 ? 1 : -1),
          vy: -Math.abs(Math.sin(angle) * speed),
          size: (5 + Math.random() * 6) * dpr,
          color: colors[Math.floor(Math.random() * colors.length)],
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.35
        });
      }
    });

    var gravity = 0.42 * dpr;
    var duration = 2800;
    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var elapsed = now - start;
      ctx.clearRect(0, 0, w, h);

      particles.forEach(function (p) {
        p.vy += gravity;
        p.vx *= 0.985;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, 1 - elapsed / duration);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.55);
        ctx.restore();
      });

      if (elapsed < duration) {
        requestAnimationFrame(frame);
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    }

    requestAnimationFrame(frame);
  }

  /* --- Poznámka k objednávke --- */
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.cart-note__input')) return;
    fetch(theme.cartUpdateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ note: event.target.value })
    });
  });

  /* ---------------------------------------------------------
     Množstvo (−/+)
     --------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.quantity__btn');
    if (!button) return;

    var wrapper = button.closest('.quantity');
    var input = $('.quantity__input', wrapper);
    if (!input) return;

    var current = parseInt(input.value, 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    var next = button.name === 'plus' ? current + 1 : current - 1;
    if (next < min) next = min;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('.quantity__input')) return;

    var wrapper = input.closest('.quantity');
    var line = wrapper && wrapper.getAttribute('data-line');
    if (!line) return;

    Cart.change(parseInt(line, 10), parseInt(input.value, 10) || 0);
  });

  /* ---------------------------------------------------------
     Výber variantu
     --------------------------------------------------------- */

  function initVariantSelects(root) {
    $$('variant-selects', root).forEach(function (container) {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      var json = $('[data-variant-json]', container);
      if (!json) return;

      var variants;
      try {
        variants = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }

      var sectionId = container.getAttribute('data-section');
      var productUrl = container.getAttribute('data-url');

      function selectedOptions() {
        var values = [];

        $$('.variant-picker__radio:checked', container).forEach(function (input) {
          var position = parseInt(input.getAttribute('data-option-position'), 10);
          values[position - 1] = input.value;
        });

        $$('.variant-picker__select', container).forEach(function (select) {
          var position = parseInt(select.getAttribute('data-option-position'), 10);
          if (position) values[position - 1] = select.value;
        });

        return values;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          var match = true;
          for (var j = 0; j < values.length; j++) {
            if (values[j] !== undefined && variant.options[j] !== values[j]) {
              match = false;
              break;
            }
          }
          if (match) return variant;
        }
        return null;
      }

      function updateLabels(values) {
        $$('[data-selected-value]', container).forEach(function (el) {
          var position = parseInt(el.getAttribute('data-selected-value'), 10);
          if (values[position - 1]) el.textContent = values[position - 1];
        });
      }

      function markUnavailable(values) {
        $$('.variant-picker__radio', container).forEach(function (input) {
          var position = parseInt(input.getAttribute('data-option-position'), 10);
          var candidate = values.slice();
          candidate[position - 1] = input.value;

          var available = variants.some(function (variant) {
            if (!variant.available) return false;
            for (var j = 0; j < candidate.length; j++) {
              if (candidate[j] !== undefined && variant.options[j] !== candidate[j]) return false;
            }
            return true;
          });

          var label = container.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      }

      function refreshSection(variant) {
        if (!sectionId || !productUrl) return;

        fetchSection('main-product', productUrl + '?variant=' + variant.id)
          .then(function (html) {
            if (!html) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');

            ['price-' + sectionId, 'buy-buttons-' + sectionId, 'sticky-atc-price-' + sectionId].forEach(function (id) {
              var source = parsed.getElementById(id);
              var target = document.getElementById(id);
              if (source && target) target.innerHTML = source.innerHTML;
            });

            var stockSource = parsed.querySelector('[data-stock-status]');
            var stockTarget = $('[data-stock-status]');
            if (stockSource && stockTarget) stockTarget.innerHTML = stockSource.innerHTML;
          })
          .catch(function () { /* ticho – cena zostane pôvodná */ });
      }

      function onChange() {
        var values = selectedOptions();
        updateLabels(values);
        markUnavailable(values);

        var variant = findVariant(values);
        var hidden = $('[data-variant-id]');
        var button = $('[data-add-button]');
        var buttonText = $('[data-add-button-text]');
        /* Prilepená lišta dole (viď initStickyAddToCart) má vlastné, inak
           pomenované tlačidlo – [data-add-button] by mu inak konkurovalo
           s tým skutočným v hore uvedených querySelectoroch. */
        var stickyButton = $('[data-sticky-add-button]');
        var stickyButtonText = $('[data-sticky-add-button-text]');

        if (!variant) {
          if (button) button.disabled = true;
          if (buttonText) buttonText.textContent = strings.unavailable || 'Nedostupné';
          if (stickyButton) stickyButton.disabled = true;
          if (stickyButtonText) stickyButtonText.textContent = strings.unavailable || 'Nedostupné';
          return;
        }

        if (hidden) hidden.value = variant.id;

        if (button) button.disabled = !variant.available;
        if (buttonText) {
          buttonText.textContent = variant.available
            ? (strings.addToCart || 'Pridať do košíka')
            : (strings.soldOut || 'Vypredané');
        }
        if (stickyButton) stickyButton.disabled = !variant.available;
        if (stickyButtonText) {
          stickyButtonText.textContent = variant.available
            ? (strings.addToCart || 'Pridať do košíka')
            : (strings.soldOut || 'Vypredané');
        }

        if (window.history.replaceState && productUrl) {
          window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
        }

        /* Prepnutie galérie na obrázok variantu */
        if (variant.featured_media) {
          var thumb = $('[data-media-thumb="' + variant.featured_media.id + '"]');
          if (thumb) thumb.click();
        }

        refreshSection(variant);
      }

      container.addEventListener('change', onChange);

      /* Počiatočné zvýraznenie nedostupných kombinácií */
      markUnavailable(selectedOptions());
    });
  }

  /* ---------------------------------------------------------
     Galéria produktu
     --------------------------------------------------------- */

  function initGallery(root) {
    $$('media-gallery', root).forEach(function (gallery) {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';

      var slides = $$('.media-gallery__slide', gallery);
      var thumbs = $$('.media-gallery__thumb', gallery);

      function show(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
        thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
      }

      function currentIndex() {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () { show(index); });
      });

      var prev = $('[data-media-prev]', gallery);
      var next = $('[data-media-next]', gallery);
      if (prev) prev.addEventListener('click', function () { show(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { show(currentIndex() + 1); });

      /* Prstom na mobile */
      var startX = null;
      var main = $('.media-gallery__main', gallery);
      if (main) {
        main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 50) show(currentIndex() + (delta < 0 ? 1 : -1));
          startX = null;
        }, { passive: true });
      }
    });
  }

  /* ---------------------------------------------------------
     Karusel produktov
     --------------------------------------------------------- */

  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (carousel) {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';

      var track = $('[data-carousel-track]', carousel);
      if (!track) return;

      /* Šípky ležia mimo .carousel (raz v hlavičke sekcie, raz plávajúce nad
         kartami), tak ich hľadáme v najbližšom rodičovi, ktorý ich obsahuje.
         Pozor: closest() začína pri samotnom prvku, takže pri hľadaní podľa
         'div' by vrátilo .carousel a v ňom by sa žiadna šípka nikdy nenašla. */
      var prev = null;
      var next = null;
      var scope = carousel.parentElement;

      while (scope) {
        prev = scope.querySelector('[data-carousel-prev]');
        next = scope.querySelector('[data-carousel-next]');
        if (prev && next) break;
        /* Za hranicu sekcie nejdeme, nech si karusely navzájom neukradnú šípky. */
        if (scope.classList && scope.classList.contains('shopify-section')) break;
        scope = scope.parentElement;
      }

      function step() {
        var card = track.firstElementChild;
        if (!card) return 320;
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 24;
        return card.offsetWidth + gap;
      }

      function updateButtons() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('scroll', debounce(updateButtons, 80), { passive: true });
      window.addEventListener('resize', debounce(updateButtons, 150));
      /* Po dopočítaní obrázkov sa šírka stopy môže zmeniť, tak prepočítame znova. */
      window.addEventListener('load', updateButtons);
      updateButtons();
    });
  }

  /* ---------------------------------------------------------
     Hlavný banner (slider)
     --------------------------------------------------------- */

  function initHero() {
    $$('hero-slider').forEach(function (hero) {
      if (hero.dataset.initialized) return;
      hero.dataset.initialized = 'true';

      var slides = $$('.hero__slide', hero);
      var dots = $$('.hero__dot', hero);
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var isAnimating = false;

      function show(next, direction) {
        // Kým nedobehne prechod z predošlého volania, ignorujeme ďalšie –
        // inak by sa pri rýchlom klikaní na šípky rozbehlo viac prekrývajúcich
        // sa animácií naraz.
        if (isAnimating) return;

        var newIndex = (next + slides.length) % slides.length;
        if (newIndex === index) return;

        isAnimating = true;

        // Smer je vždy explicitný podľa toho, kto show() zavolal (šípka
        // späť posiela 'backward'), nie odvodený z porovnania indexov – vďaka
        // tomu funguje správne aj cez "koniec-na-začiatok" (wrap).
        // Predvolene dopredu (ďalšia šípka, bodky, automatické prehrávanie).
        var forward = direction !== 'backward';
        var oldSlide = slides[index];
        var newSlide = slides[newIndex];

        oldSlide.classList.remove('is-active');
        oldSlide.classList.toggle('hero__slide--park-left', forward);

        // Nový slide musí nabehnúť z opačnej strany, než odchádza starý. Ak
        // mu z minula zostalo zaparkované nesprávne, preskočíme ho tam bez animácie.
        var needsLeftPark = !forward;
        if (newSlide.classList.contains('hero__slide--park-left') !== needsLeftPark) {
          newSlide.classList.add('hero__slide--no-transition');
          newSlide.classList.toggle('hero__slide--park-left', needsLeftPark);
          void newSlide.offsetWidth; // vynúti reflow pred zapnutím tranzície späť
          newSlide.classList.remove('hero__slide--no-transition');
        }
        newSlide.classList.add('is-active');

        // Zámok sa odomkne, až keď na novom slide reálne dobehne CSS prechod
        // transformu – nie podľa odhadovaného času, nech sa to nerozíde, keby
        // sa dĺžka tranzície niekedy zmenila len v CSS. setTimeout je len
        // poistka pre prípad, že by transitionend nenabehol vôbec (napr.
        // prefers-reduced-motion transition úplne vypína).
        var unlockTimer = setTimeout(unlock, 750);
        newSlide.addEventListener('transitionend', onTransitionEnd);

        function onTransitionEnd(event) {
          if (event.target === newSlide && event.propertyName === 'transform') unlock();
        }

        function unlock() {
          isAnimating = false;
          clearTimeout(unlockTimer);
          newSlide.removeEventListener('transitionend', onTransitionEnd);
        }

        index = newIndex;
        dots.forEach(function (dot) {
          var dotIndex = parseInt(dot.getAttribute('data-hero-dot'), 10);
          dot.classList.toggle('is-active', dotIndex === index);
          dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
        });
      }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(function () { show(index + 1); }, interval);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      // Bodky skáču na absolútnu pozíciu (nie o krok ďalej/späť ako šípky),
      // takže smer sa dá bezpečne odvodiť porovnaním indexov – na rozdiel od
      // šípok tu žiadne "koniec-na-začiatok" wrapovanie neriešime.
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var dotIndex = parseInt(dot.getAttribute('data-hero-dot'), 10);
          show(dotIndex, dotIndex < index ? 'backward' : undefined);
          start();
        });
      });

      // Šípka späť ide opačným smerom (zľava doprava) – ďalšia šípka aj
      // automatické prehrávanie idú vždy sprava doľava (pozri komentár pri
      // bodkách vyššie, prečo tie sa riadia inak).
      $$('[data-hero-prev]', hero).forEach(function (btn) {
        btn.addEventListener('click', function () {
          show(index - 1, 'backward');
          start();
        });
      });

      $$('[data-hero-next]', hero).forEach(function (btn) {
        btn.addEventListener('click', function () {
          show(index + 1);
          start();
        });
      });

      // hero.addEventListener('mouseenter', stop);
      // hero.addEventListener('mouseleave', start);

      // Keď je karta na pozadí (iné okno/panel), setInterval sa nezastaví –
      // len ho prehliadač spomalí alebo si "odloží" tiky, ktoré po návrate
      // spustí naraz. Slide sa medzitým prepína bez animácie (nič sa
      // nevykresľuje), takže to pri návrate vyzerá ako preskočenie o pár
      // bannerov naraz. Preto časovač pri skrytí karty vypneme a po návrate
      // nabehneme odznova s plným intervalom.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay = false;
      start();
    });
  }

  /* ---------------------------------------------------------
     Oznamovací pruh – striedanie správ
     --------------------------------------------------------- */

  function initAnnouncement() {
    $$('[data-announcement-rotate]').forEach(function (bar) {
      var slides = $$('.announcement-bar__slide', bar);
      if (slides.length < 2) return;

      var index = 0;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;

      setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------------------------------------------------------
     Navigácia
     --------------------------------------------------------- */

  function initNavigation() {
    var header = $('[data-header]');

    /* Bočné menu presúvame priamo pod <body>. Sekcia hlavičky je prilepená
       (sticky), čím vytvára vlastný stacking context – vnútri neho by menu
       neprebilo prekrytie ani oznamovací pruh, nech má z-index akýkoľvek. */
    var mobileNav = $('#MobileNav');
    if (mobileNav && mobileNav.parentElement !== document.body) {
      /* Po prekreslení sekcie v editore zostane starý presunutý panel v tele
         stránky – ten zahodíme, nech tam nie sú dva s rovnakým id. */
      $$('body > .mobile-nav').forEach(function (stale) {
        if (stale !== mobileNav) stale.parentElement.removeChild(stale);
      });
      document.body.appendChild(mobileNav);
    }

    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.pageYOffset > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      /* Sticky hlavička: position: sticky priamo na <header> nefunguje, lebo
         Shopify každú sekciu obalí do vlastného <div>, ktorý je presne tak
         vysoký ako hlavička – prilepený prvok sa nikdy nedostane mimo rodiča.
         Sticky preto nastavujeme až na ten obal (priamy potomok <body>). */
      var topLevelWrapper = function (el) {
        while (el && el.parentElement && el.parentElement !== document.body) {
          el = el.parentElement;
        }
        return el;
      };

      var announcementBar = $('.announcement-bar');
      var headerRoot = header.classList.contains('header--sticky') ? topLevelWrapper(header) : null;
      var barRoot = announcementBar ? topLevelWrapper(announcementBar) : null;
      var sharedWrapper = headerRoot && barRoot && headerRoot === barRoot;

      if (sharedWrapper) {
        /* Obe sekcie sú v jednom obale – stačí prilepiť ten a držia spolu. */
        headerRoot.classList.add('sticky-header-group');
      } else {
        if (barRoot) barRoot.classList.add('sticky-announcement');
        if (headerRoot) headerRoot.classList.add('sticky-header');
      }

      /* Hlavička sa lepí tesne pod oznamovací pruh – jeho výška závisí od
         obsahu aj šírky obrazovky, tak ju meriame a dáme do CSS premennej. */
      var updateAnnouncementHeight = function () {
        var height = barRoot && !sharedWrapper ? barRoot.offsetHeight : 0;
        document.documentElement.style.setProperty('--announcement-height', height + 'px');
      };

      /* --header-height používajú lepiace sa bočné stĺpce (cena na produkte
         a pod.) na výpočet, kam sa majú prilepiť pod hlavičkou. V theme.css
         bol donedávna len natvrdo odhadnutý 58px – pri väčšom logu či inom
         obsahu hlavičky (dvojriadková s navigáciou dole) to nesedelo, takže
         sa sticky stĺpec pri prvom scrolli "prichytil" na zlú, príliš nízku
         pozíciu a viditeľne poskočil oproti galérii vedľa neho. Meriame preto
         skutočnú výšku toho, čo je práve prilepené navrchu – buď spoločný
         obal (sharedWrapper), alebo pruh + hlavičku zvlášť. */
      var updateHeaderHeight = function () {
        /* Meriame priamo spodnú hranu prilepenej hlavičky cez
           getBoundingClientRect – tá vráti jej skutočnú polohu v okne bez
           ohľadu na to, či pruh a hlavička sedia v jednom obale alebo
           v dvoch samostatných (Shopify vykresľuje každú sekciu skupiny ako
           vlastný <div>, takže v praxi nastáva druhý prípad). Sčítavanie
           offsetHeight jednotlivých obalov sa pri takejto premenlivej
           štruktúre ľahko pomýli. Funguje to v oboch stavoch: pri scrolle 0
           sú obe v normálnom toku, po zascrollovaní sú prilepené na sebe –
           spodná hrana vyjde rovnako. */
        var lowest = headerRoot || barRoot;
        if (!lowest) return;

        var bottom = Math.round(lowest.getBoundingClientRect().bottom);
        if (bottom > 0) document.documentElement.style.setProperty('--header-height', bottom + 'px');
      };

      var updateStickyOffsets = function () {
        updateAnnouncementHeight();
        updateHeaderHeight();
      };

      updateStickyOffsets();
      window.addEventListener('resize', debounce(updateStickyOffsets, 150));
      window.addEventListener('load', updateStickyOffsets);

      /* Nadpisové aj bežné písmo sa dočiahne až po prvom vykreslení –
         keď sa font vymení, hlavička môže mierne zmeniť výšku (iné metriky
         písma), tak premeriame ešte raz, nech sa sticky offset nerozíde
         s realitou. */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateStickyOffsets);
      }
    }

    /* Mega menu – otvorenie klávesnicou aj myšou */
    $$('.header__nav-item--has-children').forEach(function (item) {
      var link = $('.header__nav-link', item);

      item.addEventListener('mouseenter', function () {
        item.classList.add('is-open');
        if (link) link.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-open');
        if (link) link.setAttribute('aria-expanded', 'false');
      });

      item.addEventListener('focusin', function () {
        item.classList.add('is-open');
        if (link) link.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          item.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
        }
      });
    });

    /* Mobilné menu */
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mobile-nav-open]')) {
        event.preventDefault();
        Drawers.open($('#MobileNav'));
        var toggle = event.target.closest('[data-mobile-nav-open]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      if (event.target.closest('[data-mobile-nav-close]')) {
        Drawers.close($('#MobileNav'));
        var openBtn = $('[data-mobile-nav-open]');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        return;
      }

      var submenuToggle = event.target.closest('[data-submenu-toggle]');
      if (submenuToggle) {
        var list = submenuToggle.nextElementSibling;
        var expanded = submenuToggle.getAttribute('aria-expanded') === 'true';
        submenuToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        submenuToggle.classList.toggle('is-open', !expanded);
        if (list) list.hidden = expanded;
      }
    });
  }

  /* ---------------------------------------------------------
     Vyhľadávanie
     --------------------------------------------------------- */

  function initSearch() {
    var drawer = $('#SearchDrawer');
    if (!drawer) return;

    var input = $('[data-predictive-input]', drawer);
    var results = $('[data-predictive-results]', drawer);
    var defaults = $('[data-search-default]', drawer);
    var typeField = $('[data-search-type-field]', drawer);
    var tabs = $$('[data-search-tab]', drawer);
    var activeType = 'all';

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-open]')) {
        event.preventDefault();
        Drawers.open(drawer);
      }
      if (event.target.closest('[data-search-close]')) {
        Drawers.close(drawer);
      }

      var tab = event.target.closest('[data-search-tab]');
      if (tab && drawer.contains(tab)) {
        activeType = tab.getAttribute('data-search-tab');
        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        if (typeField) typeField.value = activeType === 'product' ? 'product' : '';
        if (input && input.value.trim().length >= 2) search();
      }
    });

    if (!input || !results) return;

    var search = debounce(function () {
      var term = input.value.trim();

      if (term.length < 2) {
        results.innerHTML = '';
        if (defaults) defaults.hidden = false;
        return;
      }

      if (defaults) defaults.hidden = true;
      results.classList.add('is-loading');

      var resourceTypes = activeType === 'product' ? 'product' : 'product,collection,article,page';

      var url = theme.predictiveSearchUrl +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=' + resourceTypes +
        '&resources[limit]=6' +
        '&section_id=predictive-search';

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var content = parsed.querySelector('.shopify-section') || parsed.body;
          results.innerHTML = content ? content.innerHTML : '';
        })
        .catch(function () {
          results.innerHTML = '';
        })
        .then(function () {
          results.classList.remove('is-loading');
        });
    }, 250);

    input.addEventListener('input', search);
  }

  /* ---------------------------------------------------------
     Filtre a radenie v kolekcii
     --------------------------------------------------------- */

  function initFacets() {
    var form = $('[data-facet-form]');

    function navigate(url) {
      var grid = $('[data-product-grid]');
      if (grid) grid.classList.add('is-loading');

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');

          ['.collection-main', '.facets__form', '.collection-toolbar__count'].forEach(function (selector) {
            var source = parsed.querySelector(selector);
            var target = $(selector);
            if (source && target) target.innerHTML = source.innerHTML;
          });

          if (window.history.pushState) window.history.pushState({}, '', url);
          window.scrollTo({ top: ($('.collection-layout') || document.body).offsetTop - 100, behavior: 'smooth' });
        })
        .catch(function () {
          window.location.href = url;
        })
        .then(function () {
          var freshGrid = $('[data-product-grid]');
          if (freshGrid) freshGrid.classList.remove('is-loading');
        });
    }

    if (form) {
      form.addEventListener('change', debounce(function () {
        var params = new URLSearchParams(new FormData(form));

        /* Prázdne polia do URL nepatria */
        Array.from(params.keys()).forEach(function (key) {
          if (!params.get(key)) params.delete(key);
        });

        var query = params.toString();
        navigate(window.location.pathname + (query ? '?' + query : ''));
      }, 300));
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-facets-open]')) {
        var facets = $('#Facets');
        if (facets) {
          facets.classList.add('is-open');
          facets.hidden = false;
          showOverlay();
          lockScroll();
        }
      }

      if (event.target.closest('[data-facets-close]')) {
        var panel = $('#Facets');
        if (panel) {
          panel.classList.remove('is-open');
          hideOverlay();
          unlockScroll();
        }
      }
    });
  }

  /* ---------------------------------------------------------
     Odporúčané produkty (načítanie na požiadanie)
     --------------------------------------------------------- */

  function initRecommendations() {
    $$('product-recommendations').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;

      var load = function () {
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) {
              el.innerHTML = fresh.innerHTML;
              initCarousels(el);
            }
          })
          .catch(function () { /* sekcia jednoducho zostane prázdna */ });
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            load();
          });
        }, { rootMargin: '300px' });
        observer.observe(el);
      } else {
        load();
      }
    });
  }

  /* ---------------------------------------------------------
     Plynulé rozbaľovanie <details>
     --------------------------------------------------------- */

  /* Natívne <details> sa otvára skokom. Tu si otvorenie/zatvorenie berieme na
     starosť sami a výšku prvku preanimujeme – bez zásahu do markupu, takže to
     funguje pre zľavový kód, časté otázky aj poznámku k objednávke naraz.
     Ak prehliadač Web Animations nevie (alebo má užívateľ vypnuté animácie),
     necháme pôvodné správanie. */
  function initSmoothDetails(root) {
    if (!Element.prototype.animate) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    $$('details.accordion, details.cart-discount, details.cart-note', root || document).forEach(function (details) {
      if (details.dataset.smooth) return;
      details.dataset.smooth = 'true';

      var summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.dataset.animating === 'true') return;
        details.dataset.animating = 'true';

        var startHeight = details.offsetHeight;
        var wasOpen = details.open;
        var endHeight;

        if (wasOpen) {
          endHeight = summary.offsetHeight;
        } else {
          /* Obsah musí byť najprv v DOM-e viditeľný, inak sa cieľová výška nedá zmerať. */
          details.open = true;
          endHeight = details.offsetHeight;
        }

        details.style.overflow = 'hidden';

        var animation = details.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );

        animation.onfinish = function () {
          details.style.overflow = '';
          details.style.height = '';
          if (wasOpen) details.open = false;
          details.dataset.animating = '';
        };
      });
    });
  }

  /* ---------------------------------------------------------
     Zákaznícky účet – adresy
     --------------------------------------------------------- */

  function initAddresses() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-address-toggle]');
      if (toggle) {
        event.preventDefault();
        var target = document.getElementById(toggle.getAttribute('data-address-toggle'));
        if (target) target.hidden = !target.hidden;
        return;
      }

      var confirmBtn = event.target.closest('[data-confirm]');
      if (confirmBtn && !window.confirm(confirmBtn.getAttribute('data-confirm'))) {
        event.preventDefault();
      }
    });

    /* Kraje podľa vybranej krajiny */
    $$('[data-address-country]').forEach(function (countrySelect) {
      var wrapper = countrySelect.closest('.form-row') || countrySelect.closest('form');
      var provinceSelect = wrapper ? wrapper.querySelector('[data-address-province]') : null;
      if (!provinceSelect) return;

      var container = provinceSelect.closest('.field');

      function update() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var provinces = [];

        try {
          provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
        } catch (e) {
          provinces = [];
        }

        provinceSelect.innerHTML = '';

        if (!provinces.length) {
          if (container) container.hidden = true;
          return;
        }

        provinces.forEach(function (province) {
          var opt = document.createElement('option');
          opt.value = province[0];
          opt.textContent = province[1];
          provinceSelect.appendChild(opt);
        });

        var preset = provinceSelect.getAttribute('data-default');
        if (preset) provinceSelect.value = preset;
        if (container) container.hidden = false;
      }

      var defaultCountry = countrySelect.getAttribute('data-default');
      if (defaultCountry) countrySelect.value = defaultCountry;

      countrySelect.addEventListener('change', update);
      update();
    });
  }

  /* --- Prepínanie prihlásenie / obnova hesla --- */
  function initLoginToggle() {
    var login = $('#CustomerLogin');
    var recover = $('#RecoverPassword');
    if (!login || !recover) return;

    if (window.location.hash === '#recover') {
      login.hidden = true;
      recover.hidden = false;
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-recover-toggle]')) return;
      event.preventDefault();
      login.hidden = !login.hidden;
      recover.hidden = !recover.hidden;
    });
  }

  /* ---------------------------------------------------------
     Animácie pri scrollovaní
     --------------------------------------------------------- */

  function initAnimations() {
    if (theme.animations === false) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    /* .section-policy a .legal-page vynechávame – ide o dlhý právny text
       vložený ako jeden „section“ blok, ktorý je oveľa vyšší než okno
       prehliadača. Práh 0.08 sa počíta ako pomer viditeľnej výšky k CELKOVEJ
       výške bloku, takže pri takomto obrovskom bloku sa spoľahlivo nedosiahne
       pri žiadnej polohe scrollu – text zostane neviditeľný (opacity 0 z
       .reveal) skoro natrvalo a len náhodou „naskočí“, keď sa layout
       prepočíta (napr. po dočítaní fontu) presne v momente nad prahom. */
    $$('.section:not(.section-policy):not(.legal-page), .section-heading, .product-card, .collection-card, .blog-card, .review-collage__center').forEach(function (el) {
      el.classList.add('reveal');
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------
     Globálne zatváranie
     --------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    if (event.target.matches('[data-overlay]')) {
      Drawers.closeAll();
      Upsell.close();
      ShippingInfo.close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      Drawers.closeAll();
      Upsell.close();
      ShippingInfo.close();
    }
  });

  /* ---------------------------------------------------------
     Kopírovanie promo kódu (snippets/promo-code-badge.liquid)
     --------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-text]');
    if (!button || !navigator.clipboard) return;
    var text = button.getAttribute('data-copy-text');
    if (!text) return;
    navigator.clipboard.writeText(text).then(function () {
      button.classList.add('is-copied');
      clearTimeout(button._copyTimeout);
      button._copyTimeout = setTimeout(function () {
        button.classList.remove('is-copied');
      }, 1500);
    });
  });

  /* ---------------------------------------------------------
     Štart
     --------------------------------------------------------- */

  /* ---------------------------------------------------------
     Výber krajiny / jazyka
     --------------------------------------------------------- */

  /* Otváranie zoznamu + samotné prepnutie. Zoznam neskrývame atribútom
     `hidden` (ten je globálne display:none !important, takže by sa nedal
     animovať) – riadi ho trieda cez data-open a CSS prechod. */
  function initLocalization() {
    if (initLocalization.bound) return;
    initLocalization.bound = true;

    function closeAllExcept(keep) {
      $$('[data-loc-select]').forEach(function (select) {
        if (select === keep) return;
        select.removeAttribute('data-open');
        var toggle = select.querySelector('[data-loc-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var option = event.target.closest('[data-loc-country], [data-loc-locale]');

      if (option) {
        var form = option.closest('form');
        if (form) {
          // Jedna voľba vie naraz niesť krajinu aj jazyk (spoločný prepínač) –
          // nastavíme len tie skryté polia, pre ktoré má tlačidlo hodnotu.
          ['country', 'locale'].forEach(function (key) {
            var value = option.getAttribute('data-loc-' + key);
            if (value === null) return;
            var input = form.querySelector('[data-loc-input="' + key + '_code"]');
            if (input) input.value = value;
          });
          form.submit();
        }
        return;
      }

      var toggle = event.target.closest('[data-loc-toggle]');

      if (!toggle) {
        closeAllExcept(null);
        return;
      }

      var select = toggle.closest('[data-loc-select]');
      var isOpen = select.hasAttribute('data-open');

      closeAllExcept(select);

      if (isOpen) {
        select.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        select.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllExcept(null);
    });
  }

  function init(root) {
    initVariantSelects(root);
    initGallery(root);
    initCarousels(root);
    initSmoothDetails(root);
  }

  function boot() {
    var countBadge = $('[data-cart-count]');
    if (countBadge) Cart.currentCount = parseInt(countBadge.textContent, 10) || 0;

    var shippingBar = $('.shipping-bar');
    Cart.freeShippingUnlocked = shippingBar ? shippingBar.classList.contains('shipping-bar--reached') : false;

    init(document);
    CartUpsell.refresh();
    initHero();
    initAnnouncement();
    initNavigation();
    initSearch();
    initFacets();
    initRecommendations();
    initAddresses();
    initLoginToggle();
    initLocalization();
    initAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor – po prekreslení sekcie treba komponenty znova naviazať */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    initHero();
    initAnnouncement();
    initNavigation();
    initRecommendations();
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('cart-drawer')) Drawers.open(Cart.drawer());
  });

  /* ---------------------------------------------------------
     Product Detail Tabs (Materiál / Doprava / Vrátenie)
     --------------------------------------------------------- */

  function initProductTabs() {
    $$('[data-tabs]').forEach(function (tabsEl) {
      var tabs   = $$('.product-detail-tabs__tab', tabsEl);
      var panels = $$('.product-detail-tabs__panel', tabsEl);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-tab');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.hidden = true;
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          var target = document.getElementById('tab-' + targetId);
          if (target) {
            target.classList.add('is-active');
            target.hidden = false;
          }
        });
      });
    });
  }

  initProductTabs();

  /* ---------------------------------------------------------
     FAQ Akordeón — rich text: H3 = otázka, P = odpoveď
     --------------------------------------------------------- */

  function initFaqAccordions() {
    $$('[data-faq]').forEach(function (faqEl) {
      // Zozbieraj všetky h3 a ich nasledujúce p elementy
      var items = [];
      var children = Array.from(faqEl.children);
      var current = null;

      children.forEach(function (el) {
        var tag = el.tagName.toLowerCase();
        if (tag === 'h3' || tag === 'h2' || tag === 'b' || tag === 'strong') {
          current = { q: el.textContent.trim(), answers: [] };
          items.push(current);
        } else if (current && (tag === 'p' || tag === 'ul' || tag === 'ol')) {
          current.answers.push(el.outerHTML);
        }
      });

      if (items.length === 0) return;

      // Vyčisti a prebuduj ako akordeón
      faqEl.innerHTML = '';
      items.forEach(function (item, idx) {
        var div = document.createElement('div');
        div.className = 'faq-item';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-faq__question';
        btn.innerHTML = '<span>' + item.q + '</span><span class="product-faq__question-icon">+</span>';

        var ans = document.createElement('div');
        ans.className = 'product-faq__answer';
        ans.innerHTML = item.answers.join('') || '';

        btn.addEventListener('click', function () {
          var isOpen = div.classList.contains('is-open');
          $$('.faq-item', faqEl).forEach(function (i) { i.classList.remove('is-open'); });
          if (!isOpen) div.classList.add('is-open');
        });

        div.appendChild(btn);
        div.appendChild(ans);
        faqEl.appendChild(div);
      });
    });
  }

  initFaqAccordions();

  /* ---------------------------------------------------------
     Odhad doručenia — dátum sa počíta od dnešného dňa,
     víkendy (so, ne) sa preskakujú.
     --------------------------------------------------------- */

  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  function initDeliveryEstimate() {
    $$('[data-delivery-estimate]').forEach(function (el) {
      /* Dátum sa vypisuje na dvoch miestach – v pásiku a ešte raz v okne
         s možnosťami doručenia. To okno je ale presunuté pod <body>
         (viď initShippingInfo), takže ho tu treba dohľadať cez id z
         tlačidla, nie hľadaním v okolitom bloku. */
      var targets = $$('[data-delivery-dates]', el);
      var modalId = el.getAttribute('data-shipping-info-open');
      var modal = modalId ? document.getElementById(modalId) : null;
      if (modal) targets = targets.concat($$('[data-delivery-dates]', modal));
      if (!targets.length) return;

      var minDays = parseInt(el.getAttribute('data-min-days'), 10) || 3;
      var maxDays = parseInt(el.getAttribute('data-max-days'), 10) || 4;
      var today = new Date();
      var from = addBusinessDays(today, minDays);
      var to = addBusinessDays(today, maxDays);

      var fromStr = from.getDate() + '.' + (from.getMonth() + 1) + '.';
      var toStr = to.getDate() + '.' + (to.getMonth() + 1) + '.' + to.getFullYear();

      targets.forEach(function (target) {
        target.textContent = fromStr + '-' + toStr;
      });
    });
  }

  /* ---------------------------------------------------------
     Prilepená lišta "Pridať do košíka" dole na mobile
     --------------------------------------------------------- */

  function initStickyAddToCart() {
    var bar = $('[data-sticky-atc]');
    var anchorButton = $('[data-add-button]');
    if (!bar || !anchorButton) return;
    if (!('IntersectionObserver' in window)) return;

    /* IntersectionObserver namiesto scroll listenera – prehliadač si
       prepočítanie viditeľnosti hlavného tlačidla riadi sám, efektívnejšie
       než ručné počítanie pri každom scrolli. rootMargin odsadzuje horný
       okraj o výšku hlavičky, nech sa lišta zjaví presne vo chvíli, keď by
       reálne tlačidlo zmizelo pod ňou, nie až keď úplne opustí okno. */
    var headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    ) || 64;

    /* Bez druhého bodu (päty) by lišta od prvého odscrollovania tlačidla
       zostala vysunutá až do úplného konca stránky a prekrývala by aj
       samotnú pätu webu. Sledujeme preto oba okraje naraz a lišta sa ukáže,
       len keď nie je vidno ani jeden z nich. */
    var footer = $('footer.footer');
    var anchorVisible = true;
    var footerVisible = false;

    function sync() {
      bar.classList.toggle('is-visible', !anchorVisible && !footerVisible);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === anchorButton) anchorVisible = entry.isIntersecting;
          else if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        sync();
      },
      { rootMargin: '-' + Math.round(headerHeight) + 'px 0px 0px 0px' }
    );
    observer.observe(anchorButton);
    if (footer) observer.observe(footer);

    var stickyButton = $('[data-sticky-add-button]', bar);
    if (!stickyButton) return;

    stickyButton.addEventListener('click', function () {
      var formId = stickyButton.getAttribute('data-sticky-form');
      var form = formId ? document.getElementById(formId) : null;
      if (!form || stickyButton.disabled) return;

      /* Volá sa priamo Cart.add (nie form.requestSubmit) – tak dostane
         loading stav a spätnú väzbu TOTO tlačidlo, ktoré zákazník reálne
         klikol. Skutočný formulár nesie aktuálne zvolený variant aj
         množstvo, takže sa nič neduplikuje ani nerozchádza. */
      Cart.add(new FormData(form), stickyButton);
    });
  }

  initStickyAddToCart();
  initShippingInfo();
  initDeliveryEstimate();

  /* Sprístupnenie pre prípadné rozšírenia / aplikácie */
  window.HafaloTheme = {
    cart: Cart,
    drawers: Drawers,
    toast: toast,
    formatMoney: formatMoney
  };
})();
